module.exports = __webpack_public_path__ + "media/images/eyecatch-instagram-review-b4c3354ffc7e4e8f7c10d635207aae4a.png";